import React from 'react'
import { TextField, EmailField, UrlField, ReferenceField } from 'react-admin';

import DatagridConfigurable from '../../common/DatagridConfigurable';
import RecordSplitButton from '../../common/buttons/RecordSplitButton';
import HumanDateField from '../../common/fields/HumanDateField';
import DirectionField from '../fields/DirectionField';
import TemperatureField from '../fields/TemperatureField';
import EnrichedField from '../fields/EnrichedField';
import CampaignsField from '../fields/CampaignsField';


const LeadRow = (props) => (
    <DatagridConfigurable omit={['full_name', 'updated_at']} {...props}>
        <TextField source="full_name" label="Name" />
        <EmailField source="email" />
        <UrlField source="website" target="_blank" rel="noopener noreferrer" />
        <TextField source="company" />
        <TemperatureField source="lead_temperature" label="Temp" sortable={true} />
        <DirectionField source="direction" label="Dir" sortable={true} />
        <TextField source="source" label="Source" />
        <TextField source="status" label="Status" />
        <EnrichedField label="AI" sortable={false} />
        <ReferenceField source="created_by_id" reference="users" label="Created By" allowEmpty>
            <TextField source="fullname" />
        </ReferenceField>
        <ReferenceField source="assigned_to_id" reference="users" label="Assigned To" allowEmpty>
            <TextField source="fullname" />
        </ReferenceField>
        <CampaignsField label="Campaigns" />
        <HumanDateField source="updated_at" showTime />
        <RecordSplitButton source="actions" label="" />
    </DatagridConfigurable>
);

export default LeadRow;
